import { render } from "./ReligionCategory.vue?vue&type=template&id=7692aa70"
import script from "./ReligionCategory.vue?vue&type=script&lang=js"
export * from "./ReligionCategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__